import React from 'react'

import Background from '../../img/Tipigo-build-banner.jpg'

const styles = {
	container:{
		width:'100%',
		height:140,
		backgroundImage: `url(${Background})`
	},
	content:{
		width:'80%',
		marginLeft:'10%',
		minWidth:'1150px',
		display:'flex',
		color:'white',
		paddingTop:10,
		fontWeight:'lighter',
	},
	titleArea:{
		display:'flex',
		width:'50%',
		image:{
			height:80,
			width:80,
			borderRadius:'50%',
			marginRight:20,
			marginTop:15,
		},
		text:{
			title:{
				fontWeight:'lighter',
			},
			sub:{
				fontWeight:'lighter',
			},
		}
	},
	detailsArea:{
		width:'50%',
		paddingTop:30,
		paddingRight:15,
		details:{
			textAlign:'right',
			name:{
				fontSize:20,
				fontWeight:'lighter',

			},
			email:{
				paddingLeft:2,
				fontWeight:'lighter',
			},
		},
		faq:{
			textAlign:'right',
			text:{
				fontWeight:'lighter',
			},
			link:{
				fontWeight:'lighter',
			}
		},
	},
}

export default class BuildHeader extends React.Component {

	constructor(props) {
		super(props)
		this.state = {}
	}
	render(){
		const {firstName,lastName,email,nickname, avatar} = this.props.userDetails
		return (
			<div style={styles.container} className="pf-build-green-header">
				<div style={styles.content}>
					<div style={styles.titleArea}>
						<img style={styles.titleArea.image} src={avatar}/>
						<div style={styles.titleArea.text}>
							<h2 style={styles.titleArea.text.title}> Hello {nickname}!</h2>
							{
							// <h5 style={styles.titleArea.text.sub}>Last visit of the builder: 1/12/1924</h5>
							}
						</div>
					</div>
					<div style={styles.detailsArea}>
						<div style={styles.detailsArea.details}>
							<span style={styles.detailsArea.details.name}>{firstName} {lastName}</span> | <span style={styles.detailsArea.details.email}>{email}</span>

						</div>
						<div style={styles.detailsArea.faq}>
							<span style={styles.detailsArea.faq.text}>For our information center and FAQ page </span>
							<a style={styles.detailsArea.faq.link}>Click Here</a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/BuildHeader.js